import React, {useState} from "react"
import { FaEnvelope, FaLock } from 'react-icons/fa'
import {useDispatch} from "react-redux"
import {navigate} from "gatsby"

import "./login.scss"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Image from "../components/image"
import Header from "../components/header/header"
import Footer from "../components/footer/footer"
import ResetPassword from "../containers/resetPassword/resetPassword"
import {login} from "../redux/api/apiAction"

const LoginPage = () => {
    const dispatch = useDispatch()

    const [success, setSuccess] = useState(false)
    const [error, setError]     = useState(false)

    const [password, setPassword]   = useState(process.env.NODE_ENV !== 'production' ? "sdf" : "")
    const [email, setEmail]         = useState(process.env.NODE_ENV !== 'production' ? "antoine.delagarcie@gmail.com" : "")

    const [validationPassword, setValidationPassword]   = useState("")
    const [validationEmail, setValidationEmail]         = useState("")

    const onChange = e => {
        const {name, value} = e.target
        name === "email" ? setEmail(value) : setPassword(value)
    }

    const checkValidation = () => {
        if(email === "")
            setValidationEmail("Entrez votre email")
        else
            setValidationEmail("")

        if(password === "")
            setValidationPassword("Entrez votre mot de passe")
        else
            setValidationPassword("")

        return email.length > 0 && password.length > 0
    }

    const onSubmit = e => {
        e.preventDefault()

        if(checkValidation()) {

                dispatch(login(email, password))
                    .then(res => {
                        if(res === true) {
                            setEmail("")
                            setPassword("")
                            setSuccess(true)
                            setError(false)
                            navigate("/individual")
                        }
                        else {
                            setSuccess(false)
                            setError(true)
                        }
                    })
            
        }
        else {
            setSuccess(false)
            setError(true)
        }
    }

    return (
        <Layout main={false} className={"login"}>
            <SEO title="Connexion" />
            <Header title={null}
                    subtitle={""}
                    image={<Image filename={"cfp-header-low.png"} alt={"CFP"}/>}
            />

            <form onSubmit={onSubmit}>
                <div className="form-row">
                    <div className={"col-1"}>
                        <label><FaEnvelope/></label>
                    </div>
                    <div className={"col-11"}>
                        <input type="email" className="form-control" placeholder="Email" name={"email"} value={email} onChange={onChange} required/>
                        {validationEmail.length > 0 ?
                            <div className="invalid-feedback">
                                {validationEmail}
                            </div> : ""}
                    </div>
                </div>
                <div className="form-row">
                    <div className={"col-1"}>
                        <label><FaLock/></label>
                    </div>
                    <div className={"col-11"}>
                        <input type="password" className="form-control" placeholder="Mot de passe" name={"password"} value={password} onChange={onChange} required/>
                        {validationPassword.length > 0 ?
                            <div className="invalid-feedback">
                                {validationPassword}
                            </div> : ""}
                    </div>
                </div>
	            
                <div className={"form-row"}>
                    {error ?
                        <div className="error invalid-feedback">
                            Erreur durant la connexion
                        </div>
                    : ""}

                    {success ?
                        <div className="success valid-feedback">
                            Connexion en cours
                        </div>
                        : ""}
                </div>
            </form>

            <Footer button={"Connexion"} isButton={true} buttonAction={onSubmit}>
                <ResetPassword/>
            </Footer>
        </Layout>
    )
}

export default LoginPage
